function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.5,45.6c0,0.3-0.1,0.5-0.3,0.8l-10.1,10c-0.2,0.2-0.5,0.3-0.7,0.3c-0.3,0-0.5-0.1-0.7-0.3L3.5,46.3 c-0.3-0.3-0.4-0.7-0.2-1.1c0.2-0.4,0.5-0.6,0.9-0.6h6.1V1c0-0.3,0.1-0.5,0.3-0.7C10.8,0.1,11,0,11.3,0h6.1c0.3,0,0.5,0.1,0.7,0.3 c0.2,0.2,0.3,0.4,0.3,0.7v43.5h6.1c0.3,0,0.5,0.1,0.7,0.3S25.5,45.3,25.5,45.6z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M31.2,11.1c0-0.3,0.1-0.5,0.3-0.8l10.1-10C41.8,0.1,42.1,0,42.3,0c0.3,0,0.5,0.1,0.7,0.3l10.2,10.1 c0.3,0.3,0.4,0.7,0.2,1.1c-0.2,0.4-0.5,0.6-0.9,0.6h-6.1v43.6c0,0.3-0.1,0.5-0.3,0.7s-0.4,0.3-0.7,0.3h-6.1c-0.3,0-0.5-0.1-0.7-0.3 s-0.3-0.4-0.3-0.7V12.2h-6.1c-0.3,0-0.5-0.1-0.7-0.3S31.2,11.4,31.2,11.1z"
});

var SvgSortToggle = function SvgSortToggle(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.7 56.7",
    style: {
      enableBackground: "new 0 0 56.7 56.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSortToggle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sort-toggle.d97e458e.svg";
export { ForwardRef as ReactComponent };